import styled from 'styled-components';
import { white } from '@carbon/colors';

export const IFrameDrive = styled.iframe`
    background-color: ${white};
    border: 0;
    height: 100vh;
    width: 100%;
`;